import {useEffect, useState, type JSX} from 'react'
import {useDispatch} from 'react-redux'
import {api} from '../../store/configure-store'
import useTypedSelector from '../../hooks/use-typed-selector'
import {loggedIn, loggingOut} from '../../store/state/session-data/action-creators'
import {fetchInitialData} from '../../store/state/auth/action-creators'
import * as Styled from './system-reinitialising.styled'
import {LoadingSpinner} from '../../components/loading/loading'
import {fetchConfig} from '../../store/state/config/action-creators'
import {LogoGroup} from '../login-v2/components/header/LogoGroup'
import {loginInDataLoadedReselector} from '../login-v2/components/reselect/loginin-data-selector'

enum Status {
    UNVERIFIED = 'UNVERIFIED',
    VERIFIED = 'VERIFIED',
}

export function SystemReinitialising(): JSX.Element {
    const dispatch = useDispatch()

    const [status, setStatus] = useState(Status.UNVERIFIED)
    const allDataIsLoaded = useTypedSelector(loginInDataLoadedReselector)

    useEffect(() => {
        switch (status) {
            case Status.UNVERIFIED:
                try {
                    api.getAuth(
                        '/api/v1/auth/verify',
                        () => {
                            api.initWs()
                            dispatch(fetchConfig())
                            setStatus(Status.VERIFIED)
                        },
                        () => {
                            dispatch(loggingOut())
                        },
                    )
                } catch {
                    dispatch(loggingOut())
                }

                break

            case Status.VERIFIED:
                dispatch(fetchInitialData())
        }
    }, [status, dispatch])

    useEffect(() => {
        if (allDataIsLoaded) {
            dispatch(loggedIn())
        }
    }, [allDataIsLoaded, dispatch])

    return (
        <Styled.Screen>
            <Styled.NavigationBar>
                <Styled.NavigationContent>
                    <LogoGroup />
                </Styled.NavigationContent>
            </Styled.NavigationBar>
            <Styled.Loading>
                <LoadingSpinner size={150} />
            </Styled.Loading>
        </Styled.Screen>
    )
}
